export class QueryFilter {
  // Nom de la property de la classe métier
  Name?: string;
  // Valeur de la property
  Value?: any;
  // Valeur 2 dans le cas du between
  Value2?: object;
  // Operateur: Equal,NotEqual,Like,NotLike,In,NotIn,Lower,LowerOrEqual,Greater,GreaterOrEqual,Between
  QueryOperator?: string;
  // Nom de la propriété pour la jointure
  PropertyName?: string;
  fieldName?: string;
  // Nom de la propriété à aller chercher dans le row parent si master/detail
  parentFieldName?: string;
}
